export default "__VITE_ASSET__B_lOQ9f2__"